<template>
  <main class="main inside-page rooms-page cabinet-page">
    <div class="section rooms-section">
      <div class="wrapper">
        <div class="top">
          <div class="title">
            <span>{{ $t("Enter Room") }}</span>
          </div>
        </div>
        <div class="room-list">
          <div
            v-for="room in rooms"
            :key="room.id"
            class="room-list__item"
            :style="{
              background: `linear-gradient(${room.border_color}, #0e0e12)`,
            }"
          >
            <div class="room-list__item-wrapper">
              <img class="img" :src="room.image_url" />
              <div class="title small">
                <b>{{ room.title }}</b>
              </div>
              <router-link
                :to="`rooms/${room.slug}`"
                class="button bordered-white"
                >{{ $t("Enter") }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Rooms",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  async mounted() {
    await this.getRooms();
  },
  methods: {
    ...mapActions("rooms", ["getRooms"]),
    ...mapActions("topics", ["startRandomTopic"]),
  },
  computed: {
    ...mapGetters("rooms", ["rooms"]),
  },
};
</script>
